import { SimpleTradeCompanyListItem } from 'api';
import { TradeCompanyAutocomplete, useFormContext } from 'form';
import { useTranslation } from 'i18n';
import { useContext } from 'react';
import { SectionContainer } from 'ui';

import { PurchaseOrderFormContext } from '../../contexts/PurchaseOrderFormContext';
import { CreateFormValues } from '../../pages/PurchaseOrderCreate/PurchaseOrderCreate';

export const SellerPartiesSection = () => {
  const { t } = useTranslation('orders');
  const { setValue } = useFormContext<CreateFormValues>();
  const { defaultValues } = useContext(PurchaseOrderFormContext);
  const onSellerChange = (tradeCompany: SimpleTradeCompanyListItem) => {
    if (tradeCompany.currency) {
      setValue('seller_currency', tradeCompany.currency);
    }
    // @ts-expect-error this field is required so setting it to null raises a type error, but we need to reset it because changing the seller changes the available options to this field
    setValue('collection_site_id', null);
  };

  const onProducerChange = () => {
    // @ts-expect-error this field is required so setting it to null raises a type error, but we need to reset it because changing the producer changes the available options to this field
    setValue('production_site_id', null);
  };

  return (
    <SectionContainer title={t('sellerPartiesSection.title')} columns={2}>
      <TradeCompanyAutocomplete
        name="seller_id"
        label={t('sellerPartiesSection.sellerLabel')}
        onlySellers={true}
        excludeKycBanned
        defaultValue={defaultValues?.seller_id}
        required
        onSelectOption={onSellerChange}
        infoTooltip={t('sellerPartiesSection.sellerTooltip')}
      />
      <TradeCompanyAutocomplete
        name="producer_id"
        label={t('sellerPartiesSection.producerLabel')}
        onlySellers={true}
        excludeKycBanned
        defaultValue={defaultValues?.producer_id}
        required
        onSelectOption={onProducerChange}
        infoTooltip={t('sellerPartiesSection.producerTooltip')}
      />
      <TradeCompanyAutocomplete
        name="seller_agent_id"
        label={t('sellerPartiesSection.sellerAgentLabel')}
        defaultValue={defaultValues?.seller_agent_id}
        onlySellers={true}
        excludeKycBanned
        infoTooltip={t('sellerPartiesSection.sellerAgentTooltip')}
      />
      <TradeCompanyAutocomplete
        name="exporter_id"
        label={t('sellerPartiesSection.exporterLabel')}
        defaultValue={defaultValues?.exporter_id}
        onlySellers={true}
        excludeKycBanned
        infoTooltip={t('sellerPartiesSection.exporterTooltip')}
      />
    </SectionContainer>
  );
};
